// frontend/src/App.js
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SubscribeButton from './components/SubscribeButton';
import SubscriptionSuccess from './components/SubscriptionSuccess';
import EmailConfirmationHandler from './components/EmailConfirmationHandler';
import newsletterConfig from './config/newsletterConfig';
import authService from './services/authService';
import { initGA, trackPageView } from './Utils/analytics';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import SearchPage from './pages/SearchPage';
import UnsubscribePage from './pages/UnsubscribePage';
import AdminPanel from './pages/AdminPanel';
import TermsOfService from './components/Termsofservice';
import PrivacyPolicy from './components/Privacypolicy';
import AboutUs from './components/Aboutus';
import Contact from './components/Contact';
import Advertise from './components/Advertise';
import EditorialPolicy from './components/EditorialPolicy';
import ScrollToTop from './components/Scrolltotop';
import './App.css';
import NewsletterSubscriberAuth from "./components/NewsletterSubscriberAuth";

// 🔥 REPLACE THIS WITH YOUR ACTUAL MEASUREMENT ID FROM GOOGLE ANALYTICS
const GA_MEASUREMENT_ID = 'G-2S5FJB8576';

function App() {
  // Check if user is authenticated
  const isAuthenticated = authService.isAuthenticated();

  // Initialize Google Analytics once on app load
  useEffect(() => {
    // Only initialize in production (optional - remove if you want to track in dev too)
    if (process.env.NODE_ENV === 'production') {
      initGA(GA_MEASUREMENT_ID);
      console.log('✅ Google Analytics initialized');
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />

        {/* Newsletter subscriber auto-login - process first */}
        <NewsletterSubscriberAuth />

        {/* Other handlers */}
        <SubscriptionSuccess />
        <EmailConfirmationHandler />

        {/* Track page views on route changes */}
        <PageViewTracker />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/crypto" element={<CategoryPage category="crypto" />} />
          <Route path="/ai" element={<CategoryPage category="ai" />} />
          <Route path="/politics" element={<CategoryPage category="politics" />} />
          <Route path="/article/:id" element={<ArticleDetailPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/admin/dashboard" element={<AdminPanel />} />

          {/* Legal and Informational Pages */}
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/advertise" element={<Advertise />} />
          <Route path="/editorial-policy" element={<EditorialPolicy />} />
        </Routes>
        <Footer />

        {/* Only show floating subscribe button if NOT logged in */}
        {newsletterConfig.display.showFloatingButton && !isAuthenticated && (
          <SubscribeButton variant="floating" />
        )}
      </div>
    </Router>
  );
}

// Component to track page views on route changes
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever route changes
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
}

export default App;